// Firebase Configuration — หมออร เชียงใหม่
import { initializeApp } from 'firebase/app';
import { getFirestore, doc, getDoc, setDoc, updateDoc, addDoc, collection, query, where, getDocs, orderBy, deleteDoc, writeBatch } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyBeCfFf4CG5U83c6Uk7PPTXgpnsBZIOgwc",
    authDomain: "mor-or-chiangmai.firebaseapp.com",
    projectId: "mor-or-chiangmai",
    storageBucket: "mor-or-chiangmai.firebasestorage.app",
    messagingSenderId: "29007191972",
    appId: "1:29007191972:web:6ab8599283c016213a2b31",
    measurementId: "G-JLND9GLDTC"
};

let app = null;
let db = null;
let storage = null;
let firebaseReady = false;

export function initFirebase() {
    try {
        app = initializeApp(firebaseConfig);
        db = getFirestore(app);
        storage = getStorage(app);
        firebaseReady = true;
        console.log('🔥 Firebase initialized with Storage');
    } catch (err) {
        console.error('Firebase init error:', err);
        firebaseReady = false;
    }
}

export function isFirebaseReady() {
    return firebaseReady;
}

export { db, storage, doc, getDoc, setDoc, updateDoc, addDoc, collection, query, where, getDocs, orderBy, deleteDoc, writeBatch, ref, uploadBytes, getDownloadURL };
